export default "__VITE_ASSET__Bv6wQWjU__"